import { useMutation } from '@tanstack/react-query';
import useAxios from '../../../app/hooks/useAxios';
import queryClient from '../../../app/utils/queryClient';

const useUserUpdateProfile = () => {
	const { post } = useAxios();

	const userUpdateProfile = (profile: {
		firstName: string;
		lastName: string;
		//mobilePhone: string
	}) => {
		return post(`/users/me/profile`, profile);
	};

	return useMutation(userUpdateProfile, {
		onSuccess: () => {
			queryClient.invalidateQueries({ predicate: (query) => query.queryKey[0] === 'userProfile' });
		},
	});
};

export default useUserUpdateProfile;
